<template>
  <div class="tb-page">
    <div
      v-for="r in sim.routes"
      :key="r.id"
      class="tb-route-card"
      :class="{ active: r.id === sim.selected }"
      @click="verRuta(r.id)"
    >
      <div class="rc-top">
        <span class="rc-chip" :style="{ background: r.color }">{{ r.id }}</span>
        <div>
          <b>{{ r.nombre }}</b><br>
          <small>{{ r.origen }} → {{ r.destino }} • {{ r.stopNums.length }} paradas</small>
        </div>
        <ion-badge color="success">{{ r.buses.length }} bus</ion-badge>
      </div>
      <div class="rc-buses">
        <span v-for="b in r.buses" :key="b.placa" class="rc-bus">
          🚌 {{ b.placa }} — {{ b.vel || b.speed }} km/h
        </span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { IonBadge } from '@ionic/vue';
import { sim } from '../stores/simulation';

function verRuta(id) {
  sim.selected = id;
  sim.tab = 'mapa';
}
</script>

<style scoped>
.tb-page {
  padding: 14px; max-width: 640px; margin: 0 auto;
  display: flex; flex-direction: column; gap: 12px;
  flex: 1 1 auto; overflow-y: auto; width: 100%;
}
.tb-route-card {
  background: var(--tb-card); border-radius: 16px; padding: 14px; cursor: pointer;
  box-shadow: 0 3px 10px rgba(20, 26, 94, .08); border: 2px solid transparent;
  transition: border .15s, transform .1s;
}
.tb-route-card:active { transform: scale(.985); }
.tb-route-card.active { border-color: var(--tb-navy2); }

.rc-top { display: flex; align-items: center; gap: 12px; }
.rc-chip {
  color: #fff; font-weight: 800; border-radius: 10px;
  padding: 6px 12px; font-size: 15px; min-width: 52px; text-align: center;
}
.rc-top small { color: var(--tb-muted); }
.rc-top ion-badge { margin-left: auto; }

.rc-buses { display: flex; flex-wrap: wrap; gap: 8px; margin-top: 12px; }
.rc-bus {
  background: var(--tb-bg); border-radius: 999px; padding: 5px 12px; font-size: 12px; color: var(--tb-ink);
}
</style>
